<template lang="html">
  <b-form class="search-box-template" @submit="onSubmitSearch">
    <div class="row">
      <div class="col-sm col-input input-search">
        <b-form-input
          v-model="searchForm.keywords"
          type="text"
          placeholder="Puesto o palabras clave"
        ></b-form-input>
      </div>

      <div class="col-sm col-input">
        <b-form-select v-model="searchForm.category" v-bind:class="{ inactive: searchForm.category == null }">
          <b-form-select-option :value="null">Área de trabajo</b-form-select-option>
          <b-form-select-option :value="category.id" v-for="category in categories" :key="category.id">{{category.nombre}}</b-form-select-option>
         
        </b-form-select>
      </div>

      <div class="col-sm col-input input-map">
        <b-form-select v-model="searchForm.state" v-bind:class="{ inactive: !searchForm.state }">
          <b-form-select-option :value="null">Estado</b-form-select-option>

          <b-form-select-option :value="state.id" v-for="state in statesOpcs" :key="state.id">{{state.name}}</b-form-select-option>
         
        </b-form-select>
      </div>

      <div class="col-sm col-button">
        <b-button type="submit" class="btn-search">Buscar</b-button>
      </div>
    </div>
  </b-form>
</template>

<script>
export default {
  data(){
    return{
      searchForm: {
        keywords: null,
        category: null,
        state: null,
      },
      categories:[],
      statesOpcs:[]
    }
  },

  methods: {
    onSubmitSearch(event) {

        this.$router.push({
                      path: '/empleos',
                      query: {
                        keywords:this.searchForm.keywords,
                        category:this.searchForm.category,
                        state:this.searchForm.state,
                      }
                    });

        
    },
    getCategories(){

        axios.get(tools.url("/categoriesFront"))
        .then((response)=>{
            this.categories = response.data;
          }).catch((error)=>{
            this.$parent.handleErrors(error);
          });
    },
    getStates(){
        axios.get(tools.url("/states")).then((response)=>{
            this.statesOpcs = response.data;
          }).catch((error)=>{
          });
      },
  },
  mounted(){
    this.getCategories();
    this.getStates();
  }
}
</script>
